export const reuseDataMilestonesValidation = {
  milestones: {
    type: 'array',
    forEach: {
      type: 'object',
      _divisible: false,
      properties: {
        initialPlannedDate: {
          type: 'date',
          required: {
            value: true,
            when: {
              '$._isMarkedForDeletion': { nin: [true] },
            },
            message: 'Please fill this field',
          },
          minDate: {
            value: '$TODAY',
            message: 'Date cannot be in the past',
            when: {
              '$._isMarkedForDeletion': { nin: [true] },
            },
          },
        },
      },
    },
  },
};
